import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "North Dakota Invoice": {
    parameters: {
      linkUrls: ["https://northdakota.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Organization",
    state: "ND",
  },
  "North Dakota State Portal": {
    parameters: {
      linkUrls: ["https://northdakota.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "ND",
  },
};
